import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Switch from "react-switch";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";
import { TopTextReusableComponent } from "../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { BackLogoIconButton } from "../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { DesktopTabDesign } from "./../MainScreenTabScreen/DesktopTabDesign";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { MobileTabDesign } from "./MobileTabDesign";
import Media from "react-media";
import { MobileTopHeader } from "../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { ToggleButtonReuse } from "../AllButton/ToggleButtonReuse";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../../store/actions/authAction";
import { SliderReusableComponent } from "../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";

export const HospitalityHotelManagementScreen = ({
  state,
  localProps,
  ...props
}) => {
  let history = useHistory();
  const formik = useFormik({
    initialValues: {
      hospitality_hotels: false,
      listing: true,
      offer_management: false,
      scan_and_pay: false,
      event_management: false,
      live_streaming: false,
      ordering: false,
      menu_setup: false,
      voice_services: false,
      amenities_maintenance: false,
      spa_other_services: false,
      attraction_tour_packages: false,
      general_qa_info: false,
    },

    onSubmit: (values) => {
      const token = props?.auth?.user?.accessToken;
      const subscriptionId = props?.subscription?._id;
      let formData = props?.allSubscriptionsData;
      formData.casual_dining = false;
      formData.fast_food_dining = false;
      formData.hospitality_hotels = true;
      formData.multi_service_business = false;
      formData.hospitality_hotels_status.listing = values?.listing;
      formData.hospitality_hotels_status.offer_management =
        values?.offer_management;
      formData.hospitality_hotels_status.scan_and_pay = values?.scan_and_pay;
      formData.hospitality_hotels_status.event_management =
        values?.event_management;
      formData.hospitality_hotels_status.live_streaming =
        values?.live_streaming;
      formData.hospitality_hotels_status.ordering = values?.ordering;
      formData.hospitality_hotels_status.menu_setup = values?.menu_setup;
      formData.hospitality_hotels_status.voice_services =
        values?.voice_services;
      formData.hospitality_hotels_status.amenities_maintenance =
        values?.amenities_maintenance;
      formData.hospitality_hotels_status.spa_other_services =
        values?.spa_other_services;
      formData.hospitality_hotels_status.attraction_tour_packages =
        values?.attraction_tour_packages;
      formData.hospitality_hotels_status.general_qa_info =
        values?.general_qa_info;

      // props.update_new_subscription_for_vendor(
      //   subscriptionId,
      //   formData,
      //   token,
      //   onSuccess
      // );
    },
  });

  const onSuccess = (e) => {
    Alert.success("<h4>Subscription add successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  // useEffect(() => {
  //   if (props && props.subscriptionData) {
  //     let data = props.subscriptionData;
  //     formik.setFieldValue("listing", data.listing);
  //     formik.setFieldValue("offer_management", data.offer_management.value);
  //     formik.setFieldValue("scan_and_pay", data.scan_and_pay.value);
  //     formik.setFieldValue("event_management", data.event_management.value);
  //     formik.setFieldValue("live_streaming", data.live_streaming.value);
  //     formik.setFieldValue("ordering", data.ordering.value);
  //     formik.setFieldValue("ordering", data.ordering.value);
  //     formik.setFieldValue("menu_setup", data.menu_setup.value);
  //     formik.setFieldValue("voice_services", data.voice_services);
  //     formik.setFieldValue("manage_staff_licence", data.manage_staff_licence);
  //   }
  // }, [props.subscriptionData]);

  // const offerManagementHandler = () => {
  //   formik.setFieldValue("offer_management", !formik.values.offer_management);
  //   history.push("/casual-fine-dining/offers");
  // };
  // const scanAndPayHandler = () => {
  //   formik.setFieldValue("scan_and_pay", !formik.values.scan_and_pay);
  //   history.push("/casual-fine-dining/scanandpay");
  // };
  // const eventManagementHandler = () => {
  //   formik.setFieldValue("event_management", !formik.values.event_management);
  //   history.push("/casual-fine-dining/events");
  // };
  // const liveStreamingHandler = () => {
  //   formik.setFieldValue("live_streaming", !formik.values.live_streaming);
  //   history.push("/casual-fine-dining/livestreaming");
  // };
  // const orderingHandler = () => {
  //   formik.setFieldValue("ordering", !formik.values.ordering);
  //   history.push("/casual-fine-dining/orderingmanagement");
  // };
  // const orderingHandler = () => {
  //   formik.setFieldValue("ordering", !formik.values.ordering);
  //   history.push("/casual-fine-dining/ordering");
  // };
  // const menuSetupHandler = () => {
  //   formik.setFieldValue("menu_setup", !formik.values.menu_setup);
  //   history.push("/casual-fine-dining/menusetup");
  // };

  // if (props.auth.loader === true) {
  //   return (
  //     <React.Fragment>
  //       <AmealioLoader />
  //     </React.Fragment>
  //   );
  // } else {
  return (
    <React.Fragment>
      {/* <Media query="(min-width: 992px)">
        <div className="col-12">
          <BackLogoIconButton
            displayBackText={true}
            workWithLinkORClick={true}
            notDisplaProgressBar={true}
            displayArrow={true}
            backButtonClicked={props.backButtonClicked}
          />
        </div>
      </Media>
      <Media query="(max-width: 991px)">
        <MobileTopHeader link={true} onLink={"/subscription"} />
      </Media>
      <div className="onboarding_process_screen-button-map">
        <div>
          <TopTextReusableComponent
            headingText="Subscription"
            headingParagraph="Enter the information about the food type provided in your restaurant."
          />
        </div>
        <div>
          <Media query="(min-width: 768px)">
            <DesktopTabDesign state={state} localProps={localProps} />
          </Media>
          <Media query="(max-width: 767px)">
            <MobileTabDesign state={state} localProps={localProps} />
          </Media>
        </div> */}
      <div className="col-12 casual-fastfood-hospitality-screen">
        <ToggleButtonReuse
          mainText="Listing Service"
          checkedBox={formik.values.listing}
          noButton
          onChange={() =>
            formik.setFieldValue("listing", formik.values.listing)
          }
        />
        <ToggleButtonReuse
          mainText="Offers Management"
          checkedBox={formik.values.offer_management}
          onChange={() =>
            formik.setFieldValue(
              "offer_management",
              formik.values.offer_management
            )
          }
        />
        <ToggleButtonReuse
          mainText="Scan & Pay"
          checkedBox={formik.values.scan_and_pay}
          onChange={() =>
            formik.setFieldValue("scan_and_pay", formik.values.scan_and_pay)
          }
        />
        <ToggleButtonReuse
          mainText="Events Management"
          checkedBox={formik.values.event_management}
          onChange={() =>
            formik.setFieldValue(
              "event_management",
              formik.values.event_management
            )
          }
        />
        <ToggleButtonReuse
          mainText="Live Streaming"
          checkedBox={formik.values.live_streaming}
          onChange={() =>
            formik.setFieldValue("live_streaming", formik.values.live_streaming)
          }
        />

        <ToggleButtonReuse
          mainText="ordering"
          checkedBox={formik.values.ordering}
          onChange={() =>
            formik.setFieldValue("ordering", formik.values.ordering)
          }
        />
        <ToggleButtonReuse
          mainText="Menu Setup"
          checkedBox={formik.values.menu_setup}
          onChange={() =>
            formik.setFieldValue("menu_setup", formik.values.menu_setup)
          }
        />
        <ToggleButtonReuse
          mainText="Voice Service Enable"
          checkedBox={formik.values.voice_services}
          onChange={() =>
            formik.setFieldValue("voice_services", formik.values.voice_services)
          }
        />
        <ToggleButtonReuse
          mainText="Amenities and Maintenance"
          checkedBox={formik.values.amenities_maintenance}
          onChange={() =>
            formik.setFieldValue(
              "amenities_maintenance",
              formik.values.amenities_maintenance
            )
          }
        />
        <ToggleButtonReuse
          mainText="Spa and Other Service"
          checkedBox={formik.values.spa_other_services}
          onChange={() =>
            formik.setFieldValue(
              "spa_other_services",
              formik.values.spa_other_services
            )
          }
        />
        <ToggleButtonReuse
          mainText="Attractions and Tour Package"
          checkedBox={formik.values.attraction_tour_packages}
          onChange={() =>
            formik.setFieldValue(
              "attraction_tour_packages",
              formik.values.attraction_tour_packages
            )
          }
        />
        <ToggleButtonReuse
          mainText="General Q&A and Information"
          checkedBox={formik.values.general_qa_info}
          onChange={() =>
            formik.setFieldValue(
              "general_qa_info",
              formik.values.general_qa_info
            )
          }
        />
      </div>
      <div className="onboarding-map-setup-screen-autodetect-button ">
        <ReusableOnboardingButton
          buttonTitle="Back Button"
          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
          buttonText="Back"
          buttonType="Submit"
          onClick={props.backButtonClicked}
        />
        <ReusableOnboardingButton
          buttonTitle="Next Button"
          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
          buttonText="Done"
          buttonType="Submit"
          onClick={() => onClickSave()}
        />
      </div>
      {/* </div> */}
    </React.Fragment>
  );
  // }
};

HospitalityHotelManagementScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription: state?.onboarding?.onboard_subscription_details,
  subscriptionData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.hospitality_hotels_status,
  allSubscriptionsData: state?.onboarding?.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
})(withRouter(HospitalityHotelManagementScreen));
